module.exports = __webpack_public_path__ + "static/media/gb.fd72d9b5.svg";